import * as React from 'react';
import {Shop} from 'interfaces';
import {BREAKPOINTS} from 'utilities/breakpoints';
import {Flex, RichIcon, ImageOptions, Picture} from 'components/UIKit';
import styles from './CardScreenshot.scss';

interface Props {
  shop: Shop;
  alt: string;
}

const imageOptions: ImageOptions[] = [
  {
    breakpoint: BREAKPOINTS.mobile,
    options: {
      width: 633,
      height: 140,
    },
  },
  {
    breakpoint: BREAKPOINTS.tablet,
    fallback: true,
    options: {
      width: 233,
      height: 140,
    },
  },
  {
    breakpoint: BREAKPOINTS.desktopUp,
    options: {
      width: 268,
      height: 185,
    },
  },
];

export function CardScreenshot({shop, alt}: Props) {
  return shop.screenshots.generatedScreenshot ? (
    <Picture
      imageOptions={imageOptions}
      imageUrl={shop.screenshots.generatedScreenshot.url}
      pictureClassName={styles.Picture}
      alt={alt}
      lazyload
    />
  ) : (
    <Flex alignItems="center" justifyContent="center" className={styles.Placeholder}>
      <RichIcon icon={shop.isPrivate ? 'private' : 'noImage'} size={40} aria-hidden />
    </Flex>
  );
}
